<template>
    <div>
        <ValidationObserver ref="form">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                :validateError="errors[0]"
                                v-model="academic_year"
                            >
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="faculty_code" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="faculty_code" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="student_numbers" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student_numbers')">
                            <lined-textarea v-model="student_numbers"
                                            :validate-error="errors[0]"
                                            :styles="{ height: '15em', resize: 'both' }"
                            >
                            </lined-textarea>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="2">
                    <b-form-group class="mb-0">
                        <label class="d-none d-md-block">&nbsp;</label>
                        <b-button variant="primary" block @click="getReport">
                            {{ $t('get_report').toUpper() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import StudentReportService from "@/services/StudentReportService";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";
import qs from "qs";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        LinedTextarea,
        AcademicYearsSelectbox,
        FacultySelectbox
    },
    data() {
        return {
            academic_year: null,
            faculty_code: null,
            student_numbers: null
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.form.validate();
            if (!isValid) return;

            const studentNumbers = this.student_numbers
                ? this.student_numbers.split('\n').map(s => s.trim()).filter(Boolean)
                : null;

            const config = {
                params: {
                    academic_year: this.academic_year,
                    faculty_code: this.faculty_code,
                    student_numbers: studentNumbers,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            StudentReportService.creditStudentReport(config)
                .then(res => this._downloadFile(res, this.$t('credit_student_report') + '.xlsx'))
                .catch(err => this.showErrors(err, this.$refs.form, true))
        }
    }
}
</script>
